import { render, staticRenderFns } from "./BattlesCreateFooter.vue?vue&type=template&id=55ecc4f2&scoped=true"
import script from "./BattlesCreateFooter.vue?vue&type=script&lang=js"
export * from "./BattlesCreateFooter.vue?vue&type=script&lang=js"
import style0 from "./BattlesCreateFooter.vue?vue&type=style&index=0&id=55ecc4f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ecc4f2",
  null
  
)

export default component.exports